import { render, staticRenderFns } from "./NewAccreditationCard.vue?vue&type=template&id=1a2abc22&"
import script from "./NewAccreditationCard.ts?vue&type=script&lang=ts&"
export * from "./NewAccreditationCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports